<template>
    <div class="container mt231">
        <div class="fu-top">
            <div class="search-warp clearfix">
                <button class="search-btn fr"><i class="icons search-icon"></i></button> 
                <div class="hidden"><input class="input-text" type="text" placeholder="请输入产品名称进行搜索" v-model="searchMsg"/></div>
            </div>
        </div>
        <div class="product-warp">
            <div class="item clearfix"  v-for="(item,index) in proList" :key="index">
                <div class="tu">
                    <i class="icons" :class="'product-icon'+item.id"></i>
                    <span class="name mt20 db ac">{{item.name}}</span>
                </div>
                <div class="mask">
                    <div class="in">
                        <router-link class="color-white" :to="{path:''+$parent.baseUrl+'/productDetail',query:{id:item.id}}"  target="_blank" >
                            <h3 class="ac">{{item.name}}</h3>
                            <p class="mt20 fs12">{{item.describe}}</p>
                        </router-link>
                        <button class="kaitong" @click="oneKeyOpen(item.id,item.openState)">{{item.openText}}</button>
                    </div>
                </div>
            </div>
            <div class="no-data pt30" v-if="nodata"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            searchMsg:'',
		    data:[
               {id:15,name:'事件传播路径分析',openState:-1,openText:'一键开通',urlList:this.$baseUrl+'/eventsPath',describe:'传播路径分析指事件在互联网传播过程中，信息发布转发关系图，便于用户清晰的了解事件的发酵传播过程。用户可以通过不同形式清晰查看分析话题的传播路径，包括话题传播的平台和各平台上的媒体情况。'},
               {id:18,name:'全文检索',openState:-1,openText:'一键开通',urlList:this.$baseUrl+'/fullTextSearch',describe:'全文检索平台，用户可输入查询词在全库检索数据，不局限于方案内数据检索。'},
            ],
            nodata:false
        }
    },
    mounted() {
        let that = this;
		that.$nextTick(()=> {
            that.stateAjax();
        })
    },
    methods: {
        stateAjax(){
            let that = this;
            that.$api.get('productMarket/index/product-state-list',null, r => {
                that.$parent.returnCode(r,function(){
                    r.data.forEach((ele,index) => {
                        if(ele.is_open == 1){
                            that.proList[index].openState = 1;
                            that.proList[index].openText = '打开'
                        }else{
                            that.proList[index].openState = -1;
                            that.proList[index].openText = '一键开通'
                        }
                    })
                })
            })
        },
        oneKeyOpen(id,status){
            //this.$router.push({ path:'/productDetail',query:{id:id}})
            // let routeData = this.$router.resolve({ path: '/productDetail',query:{id:id}});
            // window.open(routeData.href, '_blank');
            let that = this;
            if(id == 11||id == 17){
                that.$utils.alertText('产品正在优化中，敬请期待！',250);
                return
            }
            if(status==1){
                that.$parent.loadModal(true,'正在跳转...'); 
                that.proList.forEach((ele,index) => {
                    if(id == ele.id){
                        that.$parent.loadModal(false); 
                        if(id === 18){
                            let routeData = that.$router.resolve({
                                path: ele.urlList
                            });
                            window.open(routeData.href, '_blank');
                        }else{
                            window.open(ele.urlList,"_blank")
                        }
                    }
                });
            }else{
                that.openState(id)
            }  
        },
        openState(id){
            let that = this;
            let data = {
                productId:id
            }
            that.$parent.loadModal(true,'正在开通...'); 
            that.$api.post('productMarket/index/open-product',{data:data}, r => {
                that.$parent.returnCode(r,function(){
                    that.proList.forEach((ele,index) => {
                        if(id == ele.id){
                            that.$parent.loadModal(false); 
                            window.open(ele.urlList,"_blank")
                        }
                    });
                })
            });
            
        }
    },
    computed: {
        proList: function() {
            let that = this;
            var _search = that.searchMsg;
            if (_search) {
                var arr=that.data.filter(function(item,index){
                    if(item.name.indexOf(_search)!=-1){
                        return item;
                    }
                },this);
                if(arr.length<=0){
                    that.nodata = true;
                    return
                }else{
                    that.nodata = false;
                }
                return arr;
            }else{
                that.nodata = false;
                return that.data;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/productCenter/product.vue